// ─── Astria GCC v2 — shared DOB persistence across all tabs. DOB is

const DOB_STORAGE_KEY = "astriaGCCV2Dob";

export const getStoredAstriaGCCV2Dob = (): string | null => {
  try {
    return localStorage.getItem(DOB_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setStoredAstriaGCCV2Dob = (dob: string): void => {
  try {
    localStorage.setItem(DOB_STORAGE_KEY, dob);
  } catch {
    // ignore storage failures (e.g. private browsing quota)
  }
};

export const clearStoredAstriaGCCV2Dob = (): void => {
  try {
    localStorage.removeItem(DOB_STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
};
